export const ACCOUNT_TYPE_OPTIONS = {
  CHECKING: 'Checking',
  SAVINGS: 'Savings',
};

export const DEPOSIT_OPTIONS = {
  STATEMENT: {
    label: 'Statement Balance. Please put statement date in comments section.',
    value: 'Statement',
  },
  PAYMENT_PLAN: {
    label: 'Payment Plan',
    value: 'Payment Plan',
  },
  PRCO_POWER: {
    label: 'PRcoPower',
    value: 'PRcoPower',
  },
  OTHER: {
    label: 'Other',
    value: 'Other',
  },
};
